import React from 'react';
import { Box, Typography, Container, Paper } from '@mui/material';

const TermsOfService: React.FC = () => {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#FFF5F5', py: 4 }}>
      <Container maxWidth="md">
        <Paper elevation={0} sx={{ p: 4, bgcolor: 'white', borderRadius: 3 }}>
          <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 700, color: '#363636' }}>
            Terms of Service
          </Typography>
          
          <Typography variant="body2" color="text.secondary" paragraph>
            Last updated: {new Date().toLocaleDateString()}
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 600 }}>
            Agreement to Terms
          </Typography>
          
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            By accessing or using WTG!, you agree to be bound by these Terms of Service. If you disagree with any part of 
            the terms, you may not access the service.
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 600 }}>
            Use License
          </Typography>
          
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Permission is granted to temporarily use WTG! for personal, non-commercial transitory viewing only. This is the 
            grant of a license, not a transfer of title, and under this license you may not:
          </Typography>
          
          <Typography component="ul" sx={{ pl: 4, lineHeight: 1.8 }}>
            <li>Modify or copy the materials</li>
            <li>Use the materials for any commercial purpose</li>
            <li>Attempt to reverse engineer any software contained in WTG!</li>
            <li>Remove any copyright or other proprietary notations from the materials</li>
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 600 }}>
            Disclaimer
          </Typography>
          
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            The materials on WTG! are provided on an 'as is' basis. Tenaba, Inc. makes no warranties, expressed or implied, 
            and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions 
            of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 600 }}>
            Contact Us
          </Typography>
          
          <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
            If you have any questions about these Terms of Service, please contact us at{' '}
            <a href="mailto:bmorioka@tenaba.com" style={{ color: '#4ECDC4', textDecoration: 'none' }}>
              bmorioka@tenaba.com
            </a>
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default TermsOfService; 